import React, {FC} from "react";
import {
    Box,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import {Logo} from "./Logo";
import {HeaderMenu} from "./HeaderMenu";
import {LanguageSwitcher} from "./LanguageSwitcher";
import {Authorization} from "./user/Authorization";
import {FacebookLink} from "./FacebookLink";

export const Header: FC = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.card.background,
                borderRadius: 2,
                p: {xs: 1, sm: 1, md: 2},
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            {isSmallScreen ? (
                <Box sx={{width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <Box sx={{display: "flex", gap: 2}}>
                        <HeaderMenu/>
                    </Box>
                    <Box sx={{display: "flex", gap: 2}}>
                        <LanguageSwitcher/>
                        <Authorization/>
                    </Box>
                </Box>
            ) : (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                    }}
                >
                    <Box sx={{flex: 1}}>
                        <Logo/>
                    </Box>
                    <Box sx={{flex: 8, display: "flex", justifyContent: "center"}}>
                        <HeaderMenu/>
                    </Box>
                    <Box sx={{display: "flex", gap: 2}}>
                        <FacebookLink/>
                        <LanguageSwitcher/>
                        <Authorization/>
                    </Box>
                </Box>
            )}
        </Box>
    );
};
